import { Link } from "react-router-dom";

export default function AuthShell({ icon: Icon, tint, title, subtitle, children, footer, testId }) {
  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 sm:py-20">
      <div className="kawaii-card p-8 sm:p-10 rise-in" data-testid={testId}>
        <Link to="/" className="inline-flex items-center gap-3 mb-8">
          <img src="/brand/logo.png" alt="Nihongo Kawaii" className="glass-orb w-12 h-12 object-cover" />
          <span className="font-display text-lg text-ink">Nihongo <span className="text-sakura-deep">Kawaii</span></span>
        </Link>
        <div className={`inline-flex items-center justify-center w-12 h-12 rounded-2xl ${tint} mb-4`}>
          <Icon className="w-5 h-5 text-ink" strokeWidth={2.5} />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl text-ink mb-2">{title}</h1>
        <p className="text-ink-soft mb-7">{subtitle}</p>
        {children}
        <div className="mt-7 space-y-2 text-sm text-ink-soft">{footer}</div>
      </div>
    </div>
  );
}
